import { Component } from '@angular/core';

@Component({
  selector: 'app-training-revamp',
  templateUrl: './training-revamp.component.html',
  styleUrl: './training-revamp.component.scss'
})
export class TrainingRevampComponent {

}
